const linkedConfimrationTemplate = `
<pwr-linked-confirmation></pwr-linked-confirmation>
`;
export default linkedConfimrationTemplate;
